<div class="modal-inner mx-1rem">
  <mat-tab-group mat-stretch-tabs [color]="'primary'">
    <ng-container *ngIf="!productInfo?.coverageData">
      <mat-tab data-cy="tab-asistencias" *ngIf="productAssists.length && productInfo.assistsFirst" label="Asistencias">
        <div class="px-4 py-4">
          <ul class="list-text">
            <li *ngFor="let assis of productAssists">
              {{assis.text}}
            </li>
          </ul>
        </div>
      </mat-tab>
    </ng-container>
    <mat-tab data-cy="tab-coberturas" [label]="productInfo?.coverageData ? '¿Qué está cubierto?' : 'Coberturas'">
      <div class="px-4 py-4">
        <ng-container *ngIf="!productInfo?.coverageData">
          <ul class="list-unstyled">
            <ng-container *ngFor="let cov of productCoverages; index as covin">
              <li *ngIf="cov.content && !cov.isAssistance" [ngClass]="{'d-none': cov.justInHome}">
                <p *ngIf="!cov?.descriptionHTML" class="title-text text-prewrap">{{cov.description}}</p>
                <div *ngIf="cov?.descriptionHTML" [innerHTML]="replaceStr(cov.descriptionHTML)"></div>
                <ng-container *ngIf="!cov?.descriptionHTML">
                  <p *ngIf="cov.infoExtra" class="break-txt">{{cov.content.trim()}}</p>
                  <p *ngIf="!cov.infoExtra" class="break-txt">{{cov.content.trim()}}*</p>
                  <p *ngIf="!cov.infoExtra" class="font-italic">
                    {{cov.asteriskText || '*Esta cobertura varía dependiendo el plan' }}</p>
                </ng-container>
                <div *ngIf="cov?.viewMore">
                  <p class="overflow-hidden text-prewrap" [ngStyle]="{'height': cov.viewMore.opened ? 'auto' : '0px'}">
                    {{cov.viewMore.content}}</p>
                  <a *ngIf="cov?.viewMore" class="cta-view-more"
                    (click)="toggleCovAccordion($event, covin)">{{cov.viewMore?.opened ? 'Ocultar': 'Ver más' }}
                    <mat-icon>{{cov.viewMore?.opened ? 'expand_less' : 'expand_more' }}</mat-icon> </a>
                </div>
              </li>
            </ng-container>
          </ul>
          <!--p class="font-italic" *ngIf="plansCount > 1">
            * El monto de la indemnización será de acuerdo al plan seleccionado.
          </p-->
        </ng-container>
        <ng-container *ngIf="productInfo?.coverageData">
          <p>{{productInfo.coverageData.title}}</p>
          <ul class="list-unstyled">
            <li *ngFor="let cov of productInfo.coverageData.list; index as asin">
              <p class="font-weight-bold">{{ cov.title }} <ng-container *ngIf="cov?.showPlan">- Plan {{planInfo.label}}
                </ng-container>
              </p>
              <p class="text-prewrap">{{ cov.text }}</p>
              <div *ngIf="cov?.viewMore">
                <p class="overflow-hidden text-prewrap" [ngStyle]="{'height': cov.viewMore.opened ? 'auto' : '0px'}">
                  {{cov.viewMore.content}}</p>
                <a *ngIf="cov?.viewMore" class="cta-view-more"
                  (click)="toggleAsisAccordion($event, asin)">{{cov.viewMore?.opened ? 'Ocultar': 'Ver más' }}
                  <mat-icon>{{cov.viewMore?.opened ? 'expand_less' : 'expand_more' }}</mat-icon> </a>
              </div>
            </li>
          </ul>
          <ng-container *ngIf="productAssists">
            <ul class="list-unstyled">
              <li *ngFor="let assis of productAssists; index as asin">
                <hr *ngIf="assis?.hasDivider" class="divider my-4" />
                <p class="font-weight-bold" *ngIf="assis?.title">{{assis.title}}</p>
                <p class="text-prewrap">{{assis.text}}</p>
                <div *ngIf="assis?.viewMore">
                  <p class="overflow-hidden text-prewrap"
                    [ngStyle]="{'height': assis.viewMore.opened ? 'auto' : '0px'}">{{assis.viewMore.content}}</p>
                  <a *ngIf="assis?.viewMore" class="cta-view-more mb-3" style="text-decoration: underline;"
                    (click)="toggleAssistsAccordion($event, asin)">{{assis.viewMore?.opened ? 'Ocultar': 'Ver más' }}
                    <mat-icon>{{assis.viewMore?.opened ? 'expand_less' : 'expand_more' }}</mat-icon> </a>
                </div>
              </li>
            </ul>
            <div *ngIf="productInfo.coverageData?.commonList" [innerHTML]="productInfo.coverageData?.commonList">
            </div>
            <ng-container *ngIf="productInfo.coverageData?.hasTips">
              <p class="font-weight-bold">Tips para sacar los mayores beneficios a tu seguro:</p>
              <ul class="list-text">
                <li>Siempre llama al <a href="tel:1700111999">1700-111-999</a> antes de acceder a cualquier servicio,
                  para garantizar la disponibilidad y evitarte cualquier contra tiempo. </li>
                <li>Recuerda que el servicio de ambulancia es el único que no requiere cita previa y funcionará en base
                  a reembolso.</li>
                <li>Para asegurarnos que nuestro proveedor de servicio de asistencia médica cuente con la información de
                  tu póliza, agenda una cita despúes de 24 hrs tras la contratación de tu seguro.
                  <br />
                  Desde el día 1 ya tienes acceso a todos los beneficios.</li>
                <li>Guarda en tu teléfono celular el número de agendamiento de citas <a
                    href="tel:1700111999">1700-111-999</a>, siempre es bueno tenerlo a la mano</li>
                <li>Antes de llamar a agendar una cita, ten a la mano el número de cédula del titular de la póliza.</li>
              </ul>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </mat-tab>
    <ng-container *ngIf="!productInfo?.coverageData">
      <mat-tab data-cy="tab-asistencias" *ngIf="productAssists.length && !productInfo.assistsFirst" label="Asistencias">
        <div class="px-4 py-4">
          <ul class="list-text text-prewrap">
            <li *ngFor="let assis of productAssists">
              {{assis.text}}
            </li>
          </ul>
        </div>
      </mat-tab>
    </ng-container>
    <mat-tab data-cy="tab-exclusiones" [label]="productInfo?.coverageData ? '¿Qué no está cubierto?' : 'Exclusiones'">
      <div *ngFor="let covEx of productExclusions.coverages; index as covin" class="px-3 py-4">
        <p class="title-text">
          {{ covEx.title }}
        </p>
        <p *ngIf="covEx.subtitle">
          {{ covEx.subtitle }}
        </p>
        <ul class="list-text" [ngClass]="{'mb-0': covEx?.viewMore}">
          <li *ngFor="let specEx of covEx.specs" [ngClass]="{
            'list-text--no-bullet': isArray(specEx)
          }">
            <ng-container *ngIf="isArray(specEx)">
              <ul class="list-inside">
                <li *ngFor="let specExIn of specEx">{{ specExIn }}</li>
              </ul>
            </ng-container>
            <ng-container *ngIf="!isArray(specEx)">
              {{ specEx }}
            </ng-container>
          </li>
        </ul>
        <ul class="list-text pseudo-accordion" [ngStyle]="{'height': covEx.viewMore?.opened ? 'auto' : '0px'}">
          <li *ngFor="let specMore of covEx.viewMore?.specs" [ngClass]="{'no-bullet': isArray(specMore)}"
            class="text-prewrap">
            <ng-container *ngIf="isArray(specMore)">
              <ul class="list-inside">
                <li *ngFor="let specExIn of specMore">{{ specExIn }}</li>
              </ul>
            </ng-container>
            <ng-container *ngIf="!isArray(specMore)">
              {{specMore}}
            </ng-container>
          </li>
        </ul>
        <a *ngIf="covEx?.viewMore" class="cta-view-more"
          (click)="toggleAccordion($event, covEx, covin)">{{covEx.viewMore?.opened ? 'Ocultar ': 'Ver' }} todas las
          exclusiones <mat-icon>{{covEx.viewMore?.opened ? 'expand_less' : 'expand_more' }}</mat-icon> </a>
        <!--mat-accordion *ngIf="covEx.viewMore">
          <mat-expansion-panel class="mt-4">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Conoce más aquí
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="pre-wrap">{{covEx.viewMore.title}}</p>
            <ul class="list-text">
              <li *ngFor="let specMore of covEx.viewMore.specs" [ngClass]="{'no-bullet': isArray(specMore)}" class="text-prewrap">
                <ng-container *ngIf="isArray(specMore)">
                  <ul class="list-inside">
                    <li *ngFor="let specExIn of specMore">{{ specExIn }}</li>
                  </ul>
                </ng-container>
                <ng-container *ngIf="!isArray(specMore)">
                  {{specMore}}
                </ng-container>
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion-->
        <p *ngIf="covEx.footerSpec">
          {{ covEx.footerSpec }}
        </p>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div class="px-3 py-4">
    <div *ngIf="moreInfoConfig" class="text-center">
      <a href="#" (click)="openMoreInfoCTA($event, moreInfoConfig)" color="accent"
        class="w-100 mb-5 mt-5 h6">{{moreInfoConfig.text}}</a>
    </div>
    <div class="d-lg-flex justify-content-around text-center">
      <button mat-flat-button color="accent" class="my-3 button-Entiendo" (click)="closeDialog()">Entiendo</button>
    </div>
    <p class="question-text"> ¿Tienes alguna duda? </p>
    <ul class="contact-list list-unstyled px-2">
      <li class="contact-item">
        <a class="contact-link" href="#" (click)="openScheduleDialog($event)">
          <mat-icon svgIcon="call_center"></mat-icon>
          <span class="contact-text">Agenda una llamada</span>
        </a>
      </li>
      <li class="contact-item">
        <a class="contact-link" href="tel:1700-111-999">
          <mat-icon svgIcon="click_to_call"></mat-icon>
          <span class="contact-text">1700-111-999</span>
        </a>
      </li>
      <li class="contact-item">
        <a class="contact-link" href="tel:02-395-7731">
          <mat-icon svgIcon="click_to_call"></mat-icon>
          <span class="contact-text">02-395-7731</span>
        </a>
      </li>
      <li class="contact-item">
        <a class="contact-link" href="mailto:chubbecuador@chubb.com">
          <mat-icon svgIcon="envelope"></mat-icon>
          <span class="contact-text">chubbecuador@chubb.com</span>
        </a>
      </li>
      <li class="contact-item">
        <a class="contact-link"
          href="https://api.whatsapp.com/send?phone=59323420092&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20seguros%20que%20Chubb%20tiene%20para%20clientes%20Banco%20Guayaquil%20😊."
          target="_blank">
          <mat-icon svgIcon="whatsapp"></mat-icon>
          <span class="contact-text">Chat Whatsapp</span>
        </a>
      </li>
    </ul>
  </div>
</div>
